/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_Points_ForInputs */

const th_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ได้`)
};

const en_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PF`)
};

const ja_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得点`)
};

const zh_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得分`)
};

const es_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PF`)
};

const pt_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PF`)
};

const id_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PM`)
};

const fr_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PP`)
};

const tl_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PP`)
};

const vi_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ĐG`)
};

const ko_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`득점`)
};

const de_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PF`)
};

const ru_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЗО`)
};

const tr_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AS`)
};

const it_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PF`)
};

const pl_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PZ`)
};

const uk_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЗО`)
};

const hi_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पअं`)
};

const ar_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`له`)
};

const ms_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MJ`)
};

const bn_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পপ`)
};

const zh_tw2_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得分`)
};

const zh_hk2_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得分`)
};

const ur_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ح`)
};

const fa_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زده`)
};

const sw_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PF`)
};

const nl_col_points_for = /** @type {(inputs: Col_Points_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PV`)
};

/**
* | output |
* | --- |
* | "PF" |
*
* @param {Col_Points_ForInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const col_points_for = /** @type {((inputs?: Col_Points_ForInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_Points_ForInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_col_points_for(inputs)
	if (locale === "ja") return ja_col_points_for(inputs)
	if (locale === "zh") return zh_col_points_for(inputs)
	if (locale === "es") return es_col_points_for(inputs)
	if (locale === "pt") return pt_col_points_for(inputs)
	if (locale === "id") return id_col_points_for(inputs)
	if (locale === "fr") return fr_col_points_for(inputs)
	if (locale === "tl") return tl_col_points_for(inputs)
	if (locale === "vi") return vi_col_points_for(inputs)
	if (locale === "ko") return ko_col_points_for(inputs)
	if (locale === "de") return de_col_points_for(inputs)
	if (locale === "ru") return ru_col_points_for(inputs)
	if (locale === "tr") return tr_col_points_for(inputs)
	if (locale === "it") return it_col_points_for(inputs)
	if (locale === "pl") return pl_col_points_for(inputs)
	if (locale === "uk") return uk_col_points_for(inputs)
	if (locale === "hi") return hi_col_points_for(inputs)
	if (locale === "ar") return ar_col_points_for(inputs)
	if (locale === "ms") return ms_col_points_for(inputs)
	if (locale === "bn") return bn_col_points_for(inputs)
	if (locale === "zh-TW") return zh_tw2_col_points_for(inputs)
	if (locale === "zh-HK") return zh_hk2_col_points_for(inputs)
	if (locale === "ur") return ur_col_points_for(inputs)
	if (locale === "fa") return fa_col_points_for(inputs)
	if (locale === "sw") return sw_col_points_for(inputs)
	if (locale === "nl") return nl_col_points_for(inputs)
	return en_col_points_for(inputs)
});